<div #mainDiv>
  @if(isLoading){
  <div class="bg-background-color py-2 z-10 px-4 border rounded-lg border-border-color flex flex-col gap-4 mx-auto">
    <div class="flex flex-row gap-2">
      <div class="skeleton w-40 h-5 rounded-lg mt-3"></div>
      <div class="skeleton-black rounded-full w-[100px] h-8 flex items-center justify-center mt-1">
        <div class="skeleton rounded-lg w-[70px] h-3"></div>
      </div>
      <div class="flex flex-row items-center gap-2 mt-1">
        <div class="skeleton rounded-lg w-[100px] h-3"></div>
        <div class="skeleton rounded-lg w-[100px] h-3"></div>
      </div>

    </div>
    <div class="flex flex-row gap-2 mt-4">
      <div class="flex flex-col gap-1">
        <div class="skeleton rounded-lg w-[60px] h-3 ml-3"></div>
        <div class="skeleton rounded-full w-[180px] h-14"></div>
      </div>
      <div class="skeleton rounded-full w-6 h-6 mt-8"></div>
      <div class="flex flex-col gap-1">
        <div class="skeleton rounded-lg w-[60px] h-3 ml-3"></div>
        <div class="skeleton rounded-full w-[180px] h-14"></div>
      </div>
      <div class="flex flex-col gap-1">
        <div class="skeleton rounded-lg w-[60px] h-3 ml-3"></div>
        <div class="skeleton rounded-full w-[150px] h-14"></div>
      </div>
      <div class="flex flex-col gap-1">
        <div class="skeleton rounded-lg w-[60px] h-3 ml-3"></div>
        <div class="skeleton rounded-full w-[150px] h-14"></div>
      </div>
      <div class="flex flex-col gap-1 mt-6">
        <div class="skeleton rounded-full w-4 h-4 ml-3"></div>
        <div class="skeleton rounded-lg w-[60px] h-3 ml-3"></div>
      </div>
      <div class="skeleton rounded-full w-6 h-6 mt-8"></div>
      <div class="flex flex-col gap-1 mt-6">
        <div class="skeleton rounded-full w-4 h-4 ml-3"></div>
        <div class="skeleton rounded-lg w-[50px] h-3 ml-3"></div>
      </div>
      <div class="skeleton rounded-full w-6 h-6 mt-8"></div>
      <div class="flex flex-col gap-1 mt-6">
        <div class="skeleton rounded-full w-4 h-4 ml-3"></div>
        <div class="skeleton rounded-lg w-[40px] h-3 ml-3"></div>
      </div>
      <div class="skeleton rounded-full w-6 h-6 mt-8"></div>
      <div class="skeleton rounded-full w-[100px] h-12 ml-2 mt-2"></div>
    </div>
  </div>}@else{
  <div class="bg-background-color py-2 pl-2 pr-4 border rounded-lg border-border-color flex flex-col gap-4 mx-auto">
    <div class="flex  gap-2.5 py-2 px-2.5"
      [ngClass]="{'flex-col' : sizeScreen < 768, 'flex-row items-center' : sizeScreen >= 768}">
      <p class="font-poppins text-md font-semibold text-title-color">
        Buscador de vuelo
      </p>
      <app-trip-type-chips (optionSelected)="onTripTypeSelected($event)" [selectedOptionId]="tripTypeSelected" />
    </div>
    <div>
      <form [formGroup]="formSearchFlight" (submit)="searchFlight()">
        <div class="flex flex-row gap-2">
          <div class="flex flex-col gap-4 w-full" formArrayName="flightDetails">
            @for (flight of flightDetailsGroups; track $index; let i = $index) {
            <div [formGroupName]="i" class="flex gap-2"
              [ngClass]="{'flex-row' : sizeScreen >= 1050, 'flex-wrap' : sizeScreen < 1050 && sizeScreen >= 768, 'flex-col' : sizeScreen < 768}">
              <div
                [ngClass]="{'w-[15%]' :  sizeScreen >= 1050 && sizeScreen < 1169 , 'w-[20%]' : sizeScreen >= 1169, 'w-[25%]' : sizeScreen < 1050 && sizeScreen >= 768, 'w-full' : sizeScreen < 768}">
                <app-autocomplete-field [label]="'ORIGEN'" [placeholder]="'Ciudad o aeropuerto'" [charsMin]="3"
                  [isLoading]="isLoadingOrigin[i]" [controlName]="'origin'" [formGroup]="flight" [index]="i" [options]="
                filteredOriginOptions[i] ? filteredOriginOptions[i].value : []
              " [isLoading]="isLoadingOrigin[i]" [displayFn]="displayFn" [highlightFn]="highlightMatch" />
              </div>
              @if(sizeScreen >= 768){
              <span class="material-symbols-outlined text-input-borderColor !w-4 !h-5 mt-4 mr-2">compare_arrows</span>
              }
              <div
                [ngClass]="{'w-[15%]' :  sizeScreen >= 1050 && sizeScreen < 1169 , 'w-[20%]' : sizeScreen >= 1169, 'w-[25%]' : sizeScreen < 1050 && sizeScreen >= 768, 'w-full' : sizeScreen < 768}">
                <app-autocomplete-field [label]="'DESTINO'" [placeholder]="'Ciudad o aeropuerto'" [charsMin]="3"
                  [isLoading]="isLoadingDestination[i]" [controlName]="'destination'" [formGroup]="flight" [index]="i"
                  [options]="
                filteredDestinationOptions[i]
                  ? filteredDestinationOptions[i].value
                  : []
              " [isLoading]="isLoadingDestination[i]" [displayFn]="displayFn" [highlightFn]="highlightMatch" />
              </div>
              <div class="min-w-[126px]"
                [ngClass]="{'w-[21%]': sizeScreen >= 1200,'w-[10%]' : sizeScreen >= 1050 && sizeScreen < 1200, 'w-[20%]' : sizeScreen < 1050 && sizeScreen >= 768, 'w-full' : sizeScreen < 768}">
                <mat-form-field appearance="outline" floatLabel="always" class="w-full">
                  <mat-label class="font-poppins">FECHA DE SALIDA</mat-label>
                  <input [min]="minDateOrigin" matInput [formControlName]="'originDate'" [matDatepicker]="dp1"
                    (keypress)="allowOnlyDateCharacters($event)" placeholder="Fecha" />
                  <mat-datepicker-toggle matIconSuffix [for]="dp1">
                    <ng-container matDatepickerToggleIcon>
                      <span class="material-symbols-outlined text-input-borderColor">
                        calendar_today
                      </span>
                    </ng-container>
                  </mat-datepicker-toggle>
                  <mat-datepicker #dp1></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="min-w-[126px]"
                [ngClass]="{'w-[21%]': sizeScreen >= 1200,'w-[10%]' : sizeScreen >= 1050 && sizeScreen < 1200, 'w-[20%]' : sizeScreen < 1050 && sizeScreen >= 768, 'w-full' : sizeScreen < 768}">
                <mat-form-field appearance="outline" floatLabel="always" class="w-full">
                  <mat-label>FECHA DE REGRESO</mat-label>
                  <input [min]="minDateDestination" matInput formControlName="destinationDate" [matDatepicker]="dp2"
                    (keypress)="allowOnlyDateCharacters($event)" placeholder="Fecha" />
                  <mat-datepicker-toggle matIconSuffix [for]="dp2">
                    <ng-container matDatepickerToggleIcon>
                      <span class="material-symbols-outlined" [ngClass]="{
        'text-gray-400': flightDetails.at(i).get('destinationDate')?.disabled,
        'text-input-borderColor': !flightDetails.at(i).get('destinationDate')?.disabled
      }">
                        calendar_today
                      </span>
                    </ng-container>
                  </mat-datepicker-toggle>
                  <mat-datepicker #dp2></mat-datepicker>
                </mat-form-field>
              </div>
              @if (flightDetails.length > 1 && i !== 0) {
              <div class=" flex justify-start items-center gap-2" [ngClass]="{'w-[80%]' : sizeScreen >= 1050} ">
                <app-button text="Agregar" [disabled]="flightDetails.length > 4" size="XSmall" type="Button"
                  (buttonClick)="addFlightDetail()" />
                @if (flightDetails.length > 1 && i !== 1) {
                <app-button color="Tertiary" text="Eliminar" size="XSmall" type="Button"
                  (buttonClick)="removeFlightDetail(i)" />
                }
              </div>
              }
              @if(i == 0 && sizeScreen >= 1050){
              <div class="flex flex-row w-[80%]">
                <div class="flex gap-2 flex-row w-[86%]">
                  <div class="w-[30%]">
                    <app-button-menu [pax]="pax" [isPax]="true" text="Pasajero" icon="person"
                      (paxChange)="updateForm($event, 'pax')" />
                  </div>
                  <div class="flex flex-row gap-2 w-[60%]">
                    <div class="w-1/2">
                      <app-button-menu text="Clase" icon="kid_star" [options]="optionClass"
                        (optionSelected)="updateForm($event, 'class')"
                        [selectedOption]="formSearchFlight.get('class')?.value" />
                    </div>
                    <div class="w-1/2">
                      <app-button-menu text="Moneda" icon="currency_exchange" [options]="optionMoney"
                        (optionSelected)="updateForm($event, 'money')"
                        [selectedOption]="formSearchFlight.get('money')?.value" />
                    </div>
                  </div>
                </div>
                <div class="-ml-5 w-[18%]">
                  <app-button color="Secondary" size="XLarge" text="Buscar" [disabled]="!formSearchFlight.valid"
                    type="Submit" />
                </div>
              </div>}
            </div>
            @if(i == flightDetailsGroups.length - 1 && sizeScreen < 1050 && sizeScreen>= 768){ <div
                class="flex flex-col w-full gap-2">
                <div class="flex w-full gap-2"
                  [ngClass]="{' flex-row w-full' : sizeScreen < 1194 && sizeScreen >= 768}">
                  <div [ngClass]="{ 'w-[40%]' : sizeScreen < 1194  && sizeScreen >= 768}">
                    <app-button-menu [pax]="pax" [isPax]="true" text="Pasajero" icon="person"
                      (paxChange)="updateForm($event, 'pax')" />
                  </div>
                  <div class="flex flex-row gap-2 w-full">
                    <div class="w-1/2">
                      <app-button-menu text="Clase" icon="kid_star" [options]="optionClass"
                        (optionSelected)="updateForm($event, 'class')"
                        [selectedOption]="formSearchFlight.get('class')?.value" />
                    </div>
                    <div class="w-1/2">
                      <app-button-menu text="Moneda" icon="currency_exchange" [options]="optionMoney"
                        (optionSelected)="updateForm($event, 'money')"
                        [selectedOption]="formSearchFlight.get('money')?.value" />
                    </div>
                  </div>
                </div>
                <div class="-ml-2 w-full">
                  <app-button color="Secondary" size="XLarge" text="Buscar" [disabled]="!formSearchFlight.valid"
                    type="Submit" />
                </div>
              </div>}
              @if(i == flightDetailsGroups.length - 1 && sizeScreen < 768){ <div
                class="flex flex-col justify-between items-center gap-4 mb-6" [ngClass]="{
        'mt-6': flightDetailsGroups.length >= 2,
        'mt-0': flightDetailsGroups.length < 2,
      }">
                <div (click)="openDialog('300ms', '300ms', 'pax')"
                  class="cursor-pointer w-full border rounded-lg border-secondary-600 p-3 flex justify-center items-center gap-4">
                  <div class="w-3 h-5 -mt-2">
                    <span class="material-symbols-outlined select-none text-sm text-secondary-600">person</span>
                  </div>
                  <p class="text-3xs text-secondary-600 font-medium">
                    {{ totalPax }} Pasajero{{ totalPax > 1 ? 's' : '' }}
                  </p>
                </div>
                <div class="flex justify-between items-center gap-2 w-full">
                  <div (click)="openDialog('300ms', '300ms', 'class')"
                    class="cursor-pointer w-[48%] border rounded-lg border-secondary-600 p-3 flex justify-center items-center gap-4">
                    <div class="w-3 h-5 -mt-2">
                      <span class="material-symbols-outlined select-none text-sm text-secondary-600">kid_star</span>
                    </div>
                    <p class="text-3xs text-secondary-600 font-medium">
                      {{ this.formSearchFlight.get('class')?.value.label }}
                    </p>
                  </div>
                  <div (click)="openDialog('300ms', '300ms', 'money')"
                    class="cursor-pointer w-[48%] border rounded-lg border-secondary-600 p-3 flex justify-center items-center gap-4">
                    <div class="w-3 h-5 -mt-2">
                      <span
                        class="material-symbols-outlined select-none text-sm text-secondary-600">currency_exchange</span>
                    </div>
                    <p class="text-3xs text-secondary-600 font-medium">
                      {{ this.formSearchFlight.get('money')?.value.label }}
                    </p>
                  </div>
                </div>
          </div>
          <div class="w-full">
            <app-button color="Secondary" text="Buscar" [disabled]="!formSearchFlight.valid || isLoading" type="Button"
              (buttonClick)="searchFlight()" />
          </div>
          }
          }
        </div>
    </div>
    </form>
  </div>
</div>}</div>